export default {
  container: "oui-react-autowhatever__container",
  containerOpen: "oui-react-autowhatever__container--open",
  itemsContainer: "oui-react-autowhatever__items-container",
  itemsContainerOpen: "oui-react-autowhatever__items-container--open",
  itemsList: "oui-react-autowhatever__items-list",
  item: "oui-react-autowhatever__item",
  itemFirst: "oui-react-autowhatever__item--first",
  itemHighlighted: "oui-react-autowhatever__item--highlighted",
  sectionContainer: "oui-react-autowhatever__section-container",
  sectionContainerFirst: "oui-react-autowhatever__section-container--first",
  sectionTitle: "oui-react-autowhatever__section-title oui-text-muted"
};
